export default {
      id: "ic_tjk_logo-usage",
      viewBox: "0 0 86 35",
      url: "/" + "images/icons.3.109.2.svg#ic_tjk_logo-usage",
      toString: function () {
        return this.url;
      }
    }